.qx-main {
  display: block;
  width: 100vw;
  height: 100vh;
}
